import * as React from "react";

const SvgIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={props.fill || "#1D252D"}
      viewBox="0 -960 960 960"
    >
      <path d="m114.69-156.16 229.16-319.99h201.23l268.76-313.77v633.76zm35.77-204.53-47.84-34.46 163.15-228.69h201.62L651.54-839l45.38 39.31-202.77 235.84H295.77zm81.39 144.53h522v-412l-182 212h-198zm522 0"></path>
    </svg>
  );
};

export default React.memo(SvgIcon);
